export default __webpack_public_path__ + "static/media/undraw_Site_content_re_4ctl.2f58c9a3.png";